import { Button, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { LockOpenRounded, LockRounded } from "@mui/icons-material";
import exportImage from "../../images/export-image.png";
import { grossDemandActions } from "../../service/grossdemand.actions";
import FileSaver from "file-saver";
import { DialogConfirmation } from "../common/DialogConfirmation";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContextOperation } from "../../context/OperationContext";
import { useHasScope } from "../../../../config/globalConfig";

const FleetPlanningToolbar = (props: any) => {
  const { setLoading } = useContext(ContextOperation);
  const { t } = useTranslation(["operation"]);
  const [open, setOpen] = useState(false);
  const [openUnfreeze, setOpenUnfreeze] = useState(false);
  const userDemand = grossDemandActions();
  const year = props.year;
  const subHeader = props.subHeader;
  const yearColor = props.yearColor;
  const hideExcelButton = props.hideExcelButton;
  const radiusTopLeft = props.radiusTopLeft === 0 ? props.radiusTopLeft : 8;
  const radiusTopRight = props.radiusTopRight === 0 ? props.radiusTopRight : 8;
  const { tenant } = useContext(ContextOperation);
  let isFrozenYear = props.isFrozenYear;
  let setIsFrozenYear = props.setIsFrozenYear;
  let isExelButton = props.isExelButton;
  let exportUrl = props.exportUrl;
  let isThirdStep = props.isThirdStep;
  let downloadThirdStepExcel = props.downloadThirdStepExcel;

  const hasScope = useHasScope;

  const downloadExcel = async () => {
    exportSegmentDemandDetermination();
  };

  const onClickOpenDialog = () => setOpen(true);
  const onClickOpenDialogUnfreeze = () => setOpenUnfreeze(true);

  const exportSegmentDemandDetermination = () => {
    setLoading(true);
    userDemand
      .exportSegmentDemandDetermination(tenant, year, exportUrl)
      .then((response: any) => {
        setLoading(false);
        const filename = response.headers["content-disposition"].split(
          "filename="
        )[1];
        var blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };

  const frezzenYears = async () => {
      let frezzenYearsObject = { yearToFreeze: year };
      await userDemand.freezeYear(tenant, frezzenYearsObject);
      await setOpen(false);
      setIsFrozenYear(true);
  };

  const unfreezeYears = async () => {
      await userDemand.unfreezeYear(tenant, year);
      await setOpenUnfreeze(false);
      setIsFrozenYear(false);
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        alignContent="center"
        sx={{
          color: useTheme().palette.primary.contrastText,
          backgroundColor: yearColor,
          borderRadius: `${radiusTopLeft}px ${radiusTopRight}px 0 0`,
          height: "50px",
        }}
        className={`${radiusTopRight ? "greyBackground" : ""}`}
      >
        <Grid item xs p={1}>
          <Typography
            className="toolbarYearClass"
            style={{ fontWeight: 800, marginLeft: 10 }}
          >
            {year} {subHeader && <span> {subHeader}</span>}
          </Typography>
        </Grid>
        {isExelButton &&
           ((isFrozenYear && hasScope("SCOPE_FLEET_PLANNING_UNFREEZE")) || (!isFrozenYear && hasScope("SCOPE_FLEET_PLANNING_FREEZE"))) && (
          <Grid
            item
            xs="auto"
            p={1.5}
            sx={{
              borderLeft: "2px solid white",
              borderRight: "2px solid white",
            }}
          >
            {(isFrozenYear === undefined || isFrozenYear === null || !isFrozenYear) && hasScope("SCOPE_FLEET_PLANNING_FREEZE") &&
            <Button
              startIcon={<LockRounded />}
              onClick={onClickOpenDialog}
              variant="text"
              style={(isFrozenYear === false) ? { color: "white" } : { color: "rgba(0, 0, 0, 0.2)"}}
              disabled={isFrozenYear === undefined || isFrozenYear === null}
            >
              {t("fleetPlanning.grossDemandDetermination.freezeYear")}
            </Button>
            }

          {isFrozenYear && hasScope("SCOPE_FLEET_PLANNING_UNFREEZE") &&
            <Button
              startIcon={<LockOpenRounded />}
              onClick={onClickOpenDialogUnfreeze}
              variant="text"
              style={{ color: "white" }}
            >
              {t("fleetPlanning.grossDemandDetermination.unfreezeYear")}
            </Button>
          }
          </Grid>
        )}

        {!hideExcelButton && (
          <Grid xs="auto" item pr={1.5}>
            <IconButton
              onClick={isThirdStep ? downloadThirdStepExcel : downloadExcel}
            >
              <img src={exportImage} alt="Excel" />
            </IconButton>
          </Grid>
        )}
      </Grid>
      <DialogConfirmation
        open={open}
        setOpen={setOpen}
        title={t("fleetPlanning.grossDemandDetermination.modalTitle")}
        message={t("fleetPlanning.grossDemandDetermination.modalBody")}
        onClickConfirmAction={frezzenYears}
      />

    <DialogConfirmation
        open={openUnfreeze}
        setOpen={setOpenUnfreeze}
        title={t("fleetPlanning.grossDemandDetermination.modalTitleUnfreeze")}
        message={t("fleetPlanning.grossDemandDetermination.modalBodyUnfreeze")}
        onClickConfirmAction={unfreezeYears}
      />
    </>
  );
};

export default FleetPlanningToolbar;
